import React from 'react'
import "./ResumingToolsPercentage.css"

const ResumingToolsPercentage = () => {
  return (
    <div className='tool-section'> 
        <div className="circle-box">
    <div className="circle-percentage">
      <svg>
        <circle cx="40" cy="40" r="40"></circle>
        <circle cx="40" cy="40" r="40"></circle>
      </svg>
      <div className="circle-number">
          <h5>75 <span>%</span></h5>
      </div>
    </div>
    <h6 className="circle-text">CSS</h6> 

    
    
  </div>

<div className="circle-box">
    <div className="circle-percentage">
      <svg>
        <circle cx="40" cy="40" r="40"></circle>
        <circle cx="40" cy="40" r="40"></circle>
      </svg>
      <div className="circle-number">
          <h5>80 <span>%</span></h5>
      </div>
    </div>
    <h6 className="circle-text">HTML</h6> 

    
    
  </div>

<div className="circle-box">
  <div className="circle-percentage">
    <svg>
      <circle cx="40" cy="40" r="40"></circle>
      <circle cx="40" cy="40" r="40"></circle>
    </svg>
    <div className="circle-number">
        <h5>77 <span>%</span></h5>
    </div>
  </div>
        <h6 className="circle-text">JAVASCRIPT</h6>
</div>

<div className="circle-box">
    <div className="circle-percentage">
      <svg>
        <circle cx="40" cy="40" r="40"></circle>
        <circle cx="40" cy="40" r="40"></circle>
      </svg>
      <div className="circle-number">
            <h5>70 <span>%</span></h5>
      </div>
    </div>
        <h6 className="circle-text">TypeScript</h6>   
  </div>

<div className="circle-box">
        <div className="circle-percentage">
          <svg>
            <circle cx="40" cy="40" r="40"></circle>
            <circle cx="40" cy="40" r="40"></circle>
          </svg>
          <div className="circle-number">
            <h5>75 <span>%</span></h5>
          </div>
        </div>
        <h6 className="circle-text">ReactJS</h6>
      </div>

      <div className="circle-box">
        <div className="circle-percentage">
          <svg>
            <circle cx="40" cy="40" r="40"></circle>
            <circle cx="40" cy="40" r="40"></circle>
          </svg>
          <div className="circle-number">
            <h5>70 <span>%</span></h5>
          </div>
        </div>
        <h6 className="circle-text">Next JS</h6>
      </div>

<div className="circle-box">
        <div className="circle-percentage">
          <svg>
            <circle cx="40" cy="40" r="40"></circle>
            <circle cx="40" cy="40" r="40"></circle>
          </svg>
          <div className="circle-number">
            <h5>60 <span>%</span></h5>
          </div>
        </div>
        <h6 className="circle-text">Nodejs / <br /> ExpressJS</h6>
      </div>
<div className="circle-box">
        <div className="circle-percentage">
          <svg>
            <circle cx="40" cy="40" r="40"></circle>
            <circle cx="40" cy="40" r="40"></circle>
          </svg>
          <div className="circle-number">
            <h5>75 <span>%</span></h5>
          </div>
        </div>
        <h6 className="circle-text">MongoDB /<br />Firebase</h6>

      </div>

<div className="circle-box">
        <div className="circle-percentage">
          <svg>
            <circle cx="40" cy="40" r="40"></circle>
            <circle cx="40" cy="40" r="40"></circle>
          </svg>
          <div className="circle-number">
            <h5>80 <span>%</span></h5>
          </div>
        </div>
        <h6 className="circle-text" style={{ lineHeight: "10px" }}>Tailwind CSS /<br />Bootstrap</h6>
      </div>

</div>
  )
}

export default ResumingToolsPercentage